<!--
 * @Author: TSC
 * @Date: 2020-04-20 12:08:16
 * @LastEditors: WLL
 * @LastEditTime: 2020-05-06 20:46:17
 -->
<template>
  <el-dropdown
    ref="dropdown"
    placement="bottom-start"
    trigger="click"
    @show="handleDropdownShow"
    @hide="handleDropdownHide"
    dropdownClass="sj-autocomplete-dropdownWrapper"
    :arrowVisible="false"
    @visible-change="onVisibleChanged"
    boundariesSelector="body"
    :appendToBody="true"
    :closeOnClick="false"
  >
    <div
      class="rich-drop-down-reference"
      :class="{ active: dropdownShow }"
      @mouseenter="handleInputEnter"
      @mouseleave="handleInputLeave"
    >
      <sj-input readonly class="drop-down-input" :value="showLabel"></sj-input>
      <i
        @click="handleClear"
        :class="[
          'icon_com',
          showClear ? 'commulti_close' : 'comselect_expand',
          'sj-autocomplete-icon',
          dropdownShow && !showClear
            ? 'sj-autocomplete-icon--show'
            : 'sj-autocomplete-icon--hide',
          {
            'sj-autocomplete-icon-clear': showClear
          }
        ]"
      ></i>
    </div>
    <el-dropdown-menu slot="dropdown">
      <div class="dropdown-menu">
        <div class="filter-row">
          <SjSearchInput
            class="search-input"
            style="flex: 1"
            v-model="searchValue"
            clearable
            @input="onSearchInput"
            theme="lightborder"
            placeholder="搜索关键词"
          />
          <SjRadio
            border
            class="dropdown-radio"
            :data="radioOptions"
            @change="onRadioChange"
            v-model="radioModel"
            :allowNull="false"
            type="button"
            size="small"
          />
        </div>
        <div class="tree-container" v-sj-loading="loading">
          <selection-tree
            ref="selectionTree"
            @expandChange="onExpandChanged"
            v-if="finalData.length"
            class="tree-wrapper"
            :data="finalData"
            :compound-optional="false"
            :default-checked-keys="selected || []"
            :default-expanded-keys.sync="defaultExpandedKeys"
            @check="handleCheck"
          ></selection-tree>
          <div v-else-if="searchValue" class="tree-search-empty">
            共0个结果
          </div>
          <SjBlank v-else />
        </div>
        <SjButton
          class="submit-button"
          size="small"
          theme="2"
          @click="onSubmitClick"
        >
          确定
        </SjButton>
      </div>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import SelectionTree from "@/components/SelectionTree/index";
import clone from "lodash.clonedeep";

export default {
  name: "RichDropDownTree",
  components: { SelectionTree },
  props: {
    showLabel: {
      type: String,
      default: ""
    },
    clearable: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    radioOptions: {
      type: Array,
      default: () => []
    },
    radioValue: {},
    selected: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: "selected",
    event: "changedSelected"
  },
  data() {
    return {
      dropdownShow: false,
      isHovering: false,
      newData: [],
      searchValue: "",
      defaultExpandedKeys: [],
      allKeys: [],
      finalData: [],
      radioModel: null
    };
  },
  computed: {
    showClear() {
      const { isHovering, clearable } = this;
      return clearable && isHovering;
    }
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(val) {
        const data = clone(val);
        const addHideField = list => {
          list.forEach(item => {
            if (Array.isArray(item.children)) {
              this.allKeys.push(item.id);
              addHideField(item.children);
            }
            item.hide = false;
          });
        };

        addHideField(data);
        this.newData = data;
        this.onSearchInput();
      }
    },
    radioValue: {
      immediate: true,
      handler(val) {
        this.radioModel = val;
      }
    }
  },
  methods: {
    onExpandChanged(key, value, name) {
      this.$emit("expandChanged", key, value, name);
    },
    onSearchInput() {
      this.finalData = [];
      if (this.searchValue && this.searchValue.trim()) {
        this.defaultExpandedKeys = this.allKeys;
      } else {
        this.defaultExpandedKeys = [];
      }

      this.$nextTick(
        () =>
          (this.finalData = this.getFilterOptions(
            this.searchValue,
            this.newData
          ))
      );
    },
    onVisibleChanged(isShow) {
      if (isShow) {
        this.handleDropdownShow();
        return;
      }
      this.handleDropdownHide();
    },
    onRadioChange(val) {
      const data = this.radioOptions.find(
        item => item.value === this.radioValue
      );
      this.$emit("radioChange", val, data.name);
    },
    handleCheck(val, item) {
      this.$emit("selectedChange", val, item);
    },
    onSubmitClick() {
      this.$emit("confirm");
      this.$refs.dropdown.hide();
    },
    handleDropdownShow() {
      this.dropdownShow = true;
      this.$emit("dropdownShow");
    },
    handleDropdownHide() {
      this.dropdownShow = false;
      this.$emit("dropdownHide");
    },
    handleInputEnter() {
      this.isHovering = true;
    },
    handleInputLeave() {
      this.isHovering = false;
    },
    handleClear(e) {
      const { showClear } = this;
      if (showClear) {
        e.stopPropagation();
        this.$emit("clear");
        this.$refs.dropdown.hide();
        if (this.$refs["selectionTree"]) {
          this.$refs["selectionTree"].clearAllChecked();
        }
      }
    },
    getFilterOptions(filteredText, options) {
      let newOptions = clone(options);
      const checkFilter = list => {
        const newList = [];
        list.forEach(item => {
          if (item) {
            if (item.children && Array.isArray(item.children)) {
              item.children = checkFilter(item.children);
              if (item.children.length) {
                newList.push(item);
              }
            } else {
              const reg = new RegExp(filteredText, "i");
              if (item.label && reg.test(item.label)) {
                newList.push(item);
              }
            }
          }
        });
        return newList;
      };
      if (filteredText) {
        newOptions = checkFilter(newOptions);
      }
      return newOptions;
    }
  }
};
</script>

<style scoped lang="less">
.rich-drop-down-reference {
  display: flex;
  cursor: pointer;
  align-items: center;
  width: 170px;
  border: 1px solid #ebebec;
  padding: 0 30px 0 10px;
  box-sizing: border-box;
  border-radius: 4px;
  position: relative;
  user-select: none;
  &.active {
    border: 1px solid #0064ff;
  }
  &:focus {
    outline: none;
  }
  .drop-down-input {
    cursor: pointer !important;
    padding: 0 !important;
  }
  .sj-autocomplete-icon {
    position: absolute;
    display: inline-block;
    right: 5px;
    top: 50%;
    cursor: pointer;
    // color: @color-normal;
    transition: transform 0.3s;

    &.sj-autocomplete-icon-clear {
      font-size: 10px;
      right: 9px;
      &:hover {
        color: @color-available;
      }
    }

    &.sj-autocomplete-icon--show {
      transform: translateY(-50%) scale(0.8) rotate(-180deg);
    }

    &.sj-autocomplete-icon--hide {
      transform: translateY(-50%) scale(0.8) rotate(0);
    }
  }
}

.dropdown-menu {
  width: 250px;
  height: 400px;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .dropdown-radio {
    margin-left: 10px;
    /deep/.radio-button-small {
      width: 43px !important;
    }
  }

  .filter-row {
    display: flex;
    margin-bottom: 10px;
    .search-input {
      &:hover {
        border-color: #0064ff;
      }
    }
  }

  .tree-container {
    flex: 1;
    min-height: 0;
    border-bottom: 1px solid #f7f8f9;

    .tree-wrapper {
      height: 100%;
      overflow-y: auto;
    }
  }

  .tree-search-empty {
    margin-top: 10px;
    text-align: left;
    .text("tiny", "light");
  }

  .submit-button {
    width: 160px;
    background-color: #399bff !important;
    border-color: #399bff !important;
    line-height: 24px;
    color: white !important;
    margin: 10px auto auto;
    align-items: center;
    display: flex !important;
    justify-content: center;
  }
}
</style>
